/**
 * InlineNotification.tsx — wrapper rundt @carbon/react InlineNotification
 *
 * Beholder vår eksisterende API (kind, title, subtitle, onClose)
 * men bruker Carbon InlineNotification internt.
 *
 * Bruk:
 *   <InlineNotification kind="error" title="Feil" subtitle="..." onClose={...} />
 */

import { ReactNode } from 'react';
import { InlineNotification as CarbonInlineNotification } from '@carbon/react';

type NotificationKind = 'error' | 'success' | 'info' | 'warning';

interface InlineNotificationProps {
  kind: NotificationKind;
  title: string;
  subtitle?: ReactNode;
  onClose?: () => void;
  className?: string;
}

export default function InlineNotification({
  kind,
  title,
  subtitle,
  onClose,
  className,
}: InlineNotificationProps) {
  return (
    <CarbonInlineNotification
      kind={kind}
      title={title}
      onClose={onClose}
      lowContrast
      className={className}
    >
      {subtitle}
    </CarbonInlineNotification>
  );
}
